import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { useLanguage } from '../../../../contexts/LanguageContext';

const ProformaItemTable = ({ items, onEdit, onDelete, onDiscountChange, type }) => {
    const { th } = useLanguage();

    const actionTemplate = (row, { rowIndex }) => (
        <div className="flex gap-1 justify-content-center">
            <Button icon="pi pi-pencil" rounded text severity="info" size="small" onClick={() => onEdit(row, rowIndex)} />
            <Button icon="pi pi-trash" rounded text severity="danger" size="small" onClick={() => onDelete(rowIndex)} />
        </div>
    );

    const warrantyTypeTemplate = (row) => {
        if (row.warrantyType === 1) return th('proformaInvoice.customerPays');
        if (row.warrantyType === 2) return th('proformaInvoice.karsanWarranty');
        return '-';
    };

    const basePriceTemplate = (row) => {
        const base = Number(row.basePrice ?? row.price ?? 0);
        return base.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const discountTemplate = (row, { rowIndex }) => {
        const handleRateChange = (val) => {
            if (onDiscountChange) {
                onDiscountChange(rowIndex, { discountRate: val ?? 0, discountAmount: row.discountAmount ?? 0 });
            }
        };
        const handleAmountChange = (val) => {
            if (onDiscountChange) {
                onDiscountChange(rowIndex, { discountRate: row.discountRate ?? 0, discountAmount: val ?? 0 });
            }
        };

        return (
            <div className="flex gap-1 align-items-center">
                <InputNumber
                    value={row.discountRate ?? 0}
                    onBlur={(e) => handleRateChange(parseFloat(e.target.value?.replace(',', '.')) || 0)}
                    onChange={(e) => handleRateChange(e.value ?? 0)}
                    suffix="%"
                    min={0}
                    max={100}
                    minFractionDigits={0}
                    maxFractionDigits={2}
                    inputStyle={{ width: '60px', padding: '2px 4px', fontSize: '0.8rem' }}
                    className="p-inputnumber-sm"
                />
                <InputNumber
                    value={row.discountAmount ?? 0}
                    onBlur={(e) => handleAmountChange(parseFloat(e.target.value?.replace(',', '.')) || 0)}
                    onChange={(e) => handleAmountChange(e.value ?? 0)}
                    prefix="₺"
                    min={0}
                    minFractionDigits={0}
                    maxFractionDigits={2}
                    inputStyle={{ width: '70px', padding: '2px 4px', fontSize: '0.8rem' }}
                    className="p-inputnumber-sm"
                />
            </div>
        );
    };

    const effectivePriceTemplate = (row) => {
        const price = Number(row.price ?? 0);
        return price.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const totalPriceTemplate = (row) => {
        const total = Number(row.totalPrice ?? 0);
        return total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    return (
        <DataTable
            value={items}
            dataKey="_uid"
            className="p-datatable-gridlines p-datatable-sm"
            showGridlines
            emptyMessage={th('common.noRecords')}
            scrollable
        >
            <Column body={actionTemplate} style={{ width: '80px' }} align="center" frozen />
            <Column field="itemCode" header={th('proformaInvoice.itemCode')} style={{ minWidth: '110px' }} />
            <Column field="itemName" header={th('proformaInvoice.itemName')} style={{ minWidth: '160px' }} />
            <Column field="quantity" header={th('proformaInvoice.quantity')} style={{ width: '80px' }} align="right" />
            <Column
                header={th('proformaInvoice.basePrice')}
                body={basePriceTemplate}
                style={{ width: '110px' }}
                align="right"
            />
            <Column
                header={th('proformaInvoice.discount')}
                body={discountTemplate}
                style={{ minWidth: '160px' }}
                align="center"
            />
            <Column
                header={th('proformaInvoice.unitPrice')}
                body={effectivePriceTemplate}
                style={{ width: '110px' }}
                align="right"
            />
            <Column
                header={th('proformaInvoice.totalPrice')}
                body={totalPriceTemplate}
                style={{ width: '120px' }}
                align="right"
            />
            <Column body={warrantyTypeTemplate} header={th('warrantyClaims.detail.partDialog.warrantyType')} style={{ minWidth: '120px' }} />
        </DataTable>
    );
};

export default ProformaItemTable;
